import { getIdToken } from '@/services/auth-service.ts';
import { showErrorNotification, showSuccessNotification } from '@/services/notification-service.ts';

interface UseCopyIdTokenReturn {
    handleCopyIdToken: () => Promise<void>;
}

const handleCopyIdToken = async (): Promise<void> => {
    try {
        const token = await getIdToken();
        if (!token) {
            showErrorNotification('Failed to copy!');
            return;
        }
        await navigator.clipboard.writeText(token);
        showSuccessNotification('Copied to clipboard!');
    } catch {
        showErrorNotification('Failed to copy!');
    }
};

export const useCopyIdToken = (): UseCopyIdTokenReturn => {
    return { handleCopyIdToken: handleCopyIdToken };
};
